import {
    BooleanField,
    DataTable,
    List,
    NumberField,
    SearchInput,
    TextField,
} from '@/components/admin';
import { Badge } from '@/components/ui/badge';
import { Card } from '@/components/ui/card';
import { useRecordContext } from 'ra-core';

const UqcBadgeField = () => {
    const record = useRecordContext();
    if (!record?.uqc) return <span className="text-slate-300 text-xs">—</span>;
    return <Badge variant="outline" className="font-mono text-xs">{record.uqc}</Badge>;
};

const filters = [
    <SearchInput key="q" source="code@ilike" placeholder="Search by code or description..." alwaysOn />,
];

export const HSNCodeList = () => (
    <List
        title="HSN Codes"
        filters={filters}
        sort={{ field: 'code', order: 'ASC' }}
        className="p-6 max-w-7xl mx-auto"
    >
        <Card className="border-none shadow-sm overflow-hidden">
            <DataTable rowClick="show">
                <DataTable.Col source="code" label="HSN/SAC Code" className="font-mono font-bold text-slate-800 tracking-wide w-28" />
                <DataTable.Col source="description" label="Description" className="text-slate-600 truncate max-w-[280px]" />
                <DataTable.Col source="category" label="Category" className="text-slate-500 text-sm w-36">
                    <TextField source="category" />
                </DataTable.Col>
                <DataTable.Col source="uqc" label="UQC" className="w-20">
                    <UqcBadgeField />
                </DataTable.Col>
                <DataTable.Col label="GST %" className="w-20">
                    <NumberField source="gst_rate" options={{ minimumFractionDigits: 0, maximumFractionDigits: 2 }} className="font-semibold text-emerald-700" />
                </DataTable.Col>
                <DataTable.Col label="CGST %" className="w-20">
                    <NumberField source="cgst_rate" options={{ minimumFractionDigits: 0, maximumFractionDigits: 2 }} className="text-slate-600" />
                </DataTable.Col>
                <DataTable.Col label="SGST %" className="w-20">
                    <NumberField source="sgst_rate" options={{ minimumFractionDigits: 0, maximumFractionDigits: 2 }} className="text-slate-600" />
                </DataTable.Col>
                <DataTable.Col label="IGST %" className="w-20">
                    <NumberField source="igst_rate" options={{ minimumFractionDigits: 0, maximumFractionDigits: 2 }} className="text-slate-600" />
                </DataTable.Col>
                <DataTable.Col label="Service?" className="w-20">
                    <BooleanField source="is_service" />
                </DataTable.Col>
            </DataTable>
        </Card>
    </List>
);
